module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/more-topic-3.0d48cbff.mp4";